/**
 * Get class labels for each metadata entry
 * @param metadata - Array of metadata objects
 * @param options - Options for label extraction
 * @returns Array of class labels
 */
export function getClassLabels(metadata, options = {}) {
    const { propertyName = 'category' } = options;
    const categories = [];
    for (const metadatum of metadata) {
        categories.push(metadatum[propertyName]);
    }
    return categories;
}
//# sourceMappingURL=getClassLabels.js.map